// app types
export enum PageDirection {
  Next = 'after',
  Previous = 'before'
}
